import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useStoreActions } from '~/contexts';
import { useAiSearchSubmit } from '~/hooks/useAiSearchSubmit';
import { ErrorResponse } from '~/infra/error-response/ErrorResponse';
import { isObject } from '~/infra/isObject';
import { withDefaultAgreementStatus } from '../agreementFilterDefaults';
import { foldAgreementBundlesIntoServices } from './agreementsBundleFold';
import { useAgreementsAiSearchStore } from './useAgreementsAiSearchStore';
const ERROR_CODES = new Set([
    'llm_timeout',
    'llm_error',
    'llm_invalid_response',
    'llm_schema_validation_failed'
]);
const isErrorCode = (value)=>typeof value === 'string' && ERROR_CODES.has(value);
const mapError = (err)=>{
    const body = new ErrorResponse(err).body;
    return isObject(body) && isErrorCode(body.error) ? body.error : 'unknown';
};
const AGREEMENTS_AI_SEARCH_TIMEOUT_MS = 10000;
const toSearchableFilter = (filter)=>withDefaultAgreementStatus(foldAgreementBundlesIntoServices(filter));
export const AGREEMENTS_AI_SEARCH_PARSE_MUTATION_KEY = [
    'agreementsAiSearchParse'
];
export const useAgreementsAiSearchSubmit = (onExtracted)=>{
    const { api } = useStoreActions();
    const actions = useAgreementsAiSearchStore(useShallow((s)=>({
            setAbortInFlight: s.setAbortInFlight,
            setFilter: s.setFilter,
            setError: s.setError,
            setUnsupported: s.setUnsupported,
            setPartial: s.setPartial
        })));
    const invoke = useCallback((args)=>api.agreementsAiSearch.invoke(args), []);
    return useAiSearchSubmit({
        mutationKey: AGREEMENTS_AI_SEARCH_PARSE_MUTATION_KEY,
        invoke,
        actions,
        mapError,
        cannotExtractCode: 'cannot_extract',
        timeoutCode: 'llm_timeout',
        timeoutMs: AGREEMENTS_AI_SEARCH_TIMEOUT_MS,
        transformFilter: toSearchableFilter,
        onExtracted
    });
};
